import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { FaqItem } from '../../types/content';
interface FaqListProps {
  items: FaqItem[];
  idPrefix: string;
}
export function FaqList({
  items,
  idPrefix
}: FaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <ul className="divide-y divide-plum/10 border-y border-plum/10" data-id="element-477" data-mp="1ygmrys1cl4sb">
      {items.map((item, index) => {
      const open = openIndex === index;
      const panelId = `${idPrefix}-panel-${index}`;
      const buttonId = `${idPrefix}-button-${index}`;
      return <li key={item.question} data-id="element-478" data-mp="27f86mc3p7znt" data-mpi={index}>
            <h3 data-id="element-479" data-mp="2c7rmjfpuz6vs">
              <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : index)} className="flex w-full items-center justify-between gap-6 py-6 text-left font-display text-lg font-semibold text-aubergine transition-colors duration-150 hover:text-copper-deep" data-id="element-480" data-mp="2c8b0klce1b4j">
                {item.question}
                <PlusIcon className={`h-5 w-5 shrink-0 text-copper transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-481" data-mp="1wpv3rvfozkxt" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-482" data-mp="1msgnpwxoky61">
              {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-483" data-mp="1hsb3h1tqqdxz">
                  <p className="max-w-prose pb-6 leading-relaxed text-plum/70" data-id="element-484" data-mp="336oxeqxcrd09">{item.answer}</p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}